import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../styles/diario.scss'
import Moment from 'moment';

const Obra = (props) => {

    const dataInicio = Moment(props.obr.dataInicio).utc(false).format("DD [de] MMMM [de] YYYY")

    function renderButtons(props) {
        const buttons = [];

        if (props.obr.anexos) {
            props.obr.anexos.forEach((anexo, index) => {
                buttons.push(
                    <Fragment key={`anexo-${index}`}>
                        <a href={anexo.arquivo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">{anexo.nomeAnexo}</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            });
        }
        return buttons;
    }

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.obr.nome} em {props.obr.local}</h5></Card.Header>
                    <Card.Body>
                        <p>Data de início: {dataInicio}</p>
                        <p>Etapa atual: {props.obr.etapa}</p>
                        <p>Valor: {props.obr.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                        <p>Empresa responsável: {props.obr.empresa}</p>
                        <p>Percentual concluído: {props.obr.percentualConcluido}</p>
                        <p>Situação atual: {props.obr.situacao}</p>
                        <p>Previsão de conclusão: {props.obr.previsaoConclusao}</p>
                        {props.obr.situacao === "Paralizada" ? 
                        <Fragment>
                            <p>Motivo da paralização: {props.obr.motivoParalizacao}</p>
                            <p>Responsável pela paralização: {props.obr.responsavelParalizacao}</p>
                            <p>Previsão de Retomada das Obras: {props.obr.previsaoReinicio}</p>
                        </Fragment>
                        : null}
                        <hr/>
                        {renderButtons(props)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Obra;